import type { DrawableMixin } from "../objects/drawable_mixin"
import PathObject from "../objects/path"
import Form from "./base"
import Calc from "@/common/util/calculator"
import { bulgePath, bulgePathExportOutline } from "@/signomatic/util/shapes"

export default class BulgeForm extends Form {
  protected path(width: number) {
    return new PathObject(this.commands(width), this.defaultParams)
  }

  protected commands(width: number) {
    return this.isEngraving ? bulgePathExportOutline(width) : bulgePath(width)
  }

  protected cutlineGappedPath(width: number, height: number): DrawableMixin | undefined {
    if (this.isEtchedAluminiumSign()) {
      const commands = this.bulgeCutLine(width, height).join("")

      const path = new PathObject(commands, {
        ...this.defaultParams,
        stroke: "#f08894",
        strokeWidth: this.drawables.cutlineWidth,
        fill: "transparent",
      })

      return path
    }

    return
  }

  protected bulgeCutLine(width: number, height: number): string[] {
    const legLength = Calc.mmToPx(2.5)
    const gap = this.gapLength()

    const w = width / 2
    const h = height / 2
    const centerX = 0
    const centerY = 0
    const segments: string[] = []

    // ===== Segment 1: Top → Right =====
    const s1 = []
    s1.push(this.pathMoveTo(centerX, -h - legLength))
    s1.push(this.pathLineToAbs(centerX, -h))
    s1.push(this.pathCurveAbs(centerX, -h, centerX + 50, -h - 0.5, centerX + 95, -h + 10))
    s1.push(this.pathCurveAbs(centerX + 95, -h + 11.5, w + 0.5, -h + 11, w, centerY - gap))
    segments.push(s1.join(" "))

    // ===== Segment 2: Right → Left =====
    const s2 = []
    s2.push(this.pathMoveTo(w + legLength, centerY))
    s2.push(this.pathLineToAbs(w, centerY))

    // Bend from the right leg down to the left
    s2.push(this.pathCurveAbs(w, centerY, w + 2, h - 14.5, centerX + 95, h - 9.5))

    // Bend from this point to the center
    s2.push(this.pathCurveAbs(centerX + 95, h - 8, centerX + 50, h + 0.5, centerX, h))

    // Bend from center to left
    s2.push(this.pathCurveAbs(centerX, h, centerX - 50, h, centerX - 95, h - 10))

    // Bend from the left side to the left leg
    s2.push(this.pathCurveAbs(centerX - 95, h - 11, -w - 0.5, h - 11.5, -w, centerY + gap))

    segments.push(s2.join(" "))

    // ===== Segment 3: Left → Top =====
    const s3 = []
    s3.push(this.pathMoveTo(-w - legLength, centerY))
    s3.push(this.pathLineToAbs(-w, centerY))
    s3.push(this.pathCurveAbs(-w, centerY, -w - 2, -h + 16, centerX - 95, -h + 9.5))
    s3.push(this.pathCurveAbs(centerX - 95, -h + 8, centerX - 50, -h - 1, centerX - gap, -h))

    segments.push(s3.join(" "))

    return segments
  }
}
